import * as api from '@/api/user'
import * as TYPES from './type';

export default {
  //用户登录
  async getLoginCode({ commit, state }, { t, cb, }) {
    const result = await api.reqLoginCode(t)
    commit(TYPES.LOGIN_CODE, { result })
    cb && cb()
  },
  async postUserLogin({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserLogin(paramets)
    if (result.code == 200) {
      const token = result.result.token
      const user = result.result.userInfo.id
      window.localStorage.setItem('Authorization', token)
      if (window.localStorage.getItem('oldUser') == null) {
        window.localStorage.setItem('oldUser', user)
      }
      if (window.localStorage.getItem('oldUser') != user) {
        window.localStorage.setItem('oldUser', window.localStorage.getItem('user'))
      }
      window.localStorage.setItem('user', user)
      commit(TYPES.USER_LOGIN, { result })
    } else if (result.code == 400) {
      const info = { result }
      commit(TYPES.USER_LOGIN, { result: info })
    }
    cb && cb()
  },
  async postUserLogout({ commit, state }, cb) {
    const result = await api.reqUserLogout()
    window.localStorage.setItem('Authorization', '')
    commit(TYPES.USER_LOGIN, { result: {} })
    cb && cb()
  },
  async getGetUserInfoByToken({ commit, state }, cb) {
    const result = await api.reqGetUserInfoByToken()
    commit(TYPES.USER_LOGIN, { result })
    cb && cb()
  },
  async getUserInfo({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserInfo(paramets)
    commit(TYPES.USER_INFO, { result })
    cb && cb()
  },

  async putUserAvatarEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserAvatarEdit(paramets)
    commit(TYPES.USER_INFO_EDIT, { result, type: 'avatar' })
    cb && cb()
  },

  async putUserPhoneEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserPhoneEdit(paramets)
    commit(TYPES.USER_INFO_EDIT, { result, type: 'phone' })
    cb && cb()
  },

  async putUserPwdEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserPwdEdit(paramets)
    commit(TYPES.USER_INFO_EDIT, { result, type: 'pwd' })
    cb && cb()
  },
  //用户修改密码强度
  async putUserPwdinquire({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserPwdinquire(paramets)
    commit(TYPES.USER_INFO_INQUIRE, { result })
    cb && cb()
  },
  //首页左上 list
  async getTabDataList({ commit, state }, { paramets, cb }) {
    const result = await api.reqTabDataList(paramets)
    commit(TYPES.TEAMESSAGE, { result })
    cb && cb()
  },
  //首页中间 list
  async getCentreDataList({ commit, state }, { paramets, cb }) {
    const result = await api.reqCentreDataList(paramets)
    commit(TYPES.CENTREMESSAGE, { result })
    cb && cb()
  },
  //首页右上 list
  async getCourseDataList({ commit, state }, { paramets, cb }) {
    const result = await api.reqCourseDataList(paramets)
    commit(TYPES.COURSEMESSAGE, { result })
    cb && cb()
  },
  //首页底部 list
  async getBaseDataList({ commit, state }, { paramets, cb }) {
    const result = await api.reqBaseDataList(paramets)
    commit(TYPES.BASEMESSAGE, { result })
    cb && cb()
  },

  //首页课程评价 list
  async getjxEvaluationList({ commit, state }, { paramets, cb }) {
    const result = await api.reqjxEvaluationList(paramets)
    commit(TYPES.BASE_EVALUATION_LIST, { result })
    cb && cb()
  },
  //首页课程评价 del
  async deljxEvaluationDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqjxEvaluationDel(paramets)
    commit(TYPES.BASE_EVALUATION_DEL, { result })
    cb && cb()
  },

  async getjxTalkList({ commit, state }, { paramets, cb }) {
    const result = await api.reqjxTalkList(paramets)
    commit(TYPES.JXTALK_LIST, { result })
    cb && cb()
  },
  //获取登录用户分值
  async getUserLoginScore({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserLoginScore(paramets)
    commit(TYPES.USER_LOGIN_SCORE, { result})
    cb && cb()
  },
  //添加List集合
  async getListGather({ commit, state }, { paramets, cb }) {
    const result = await api.reqListGather(paramets)
    commit(TYPES.USER_LIST_GATHER, { result})
    cb && cb()
  },

  async getGetQQbind({ commit, state }, { paramets, cb }) {
    const result = await api.reqGetQQbind(paramets)
    commit(TYPES.USER_THIRD_LOGIN, { result, type: 'list' })
    cb && cb()
  },

  async deleteDelQQbind({ commit, state }, { paramets, cb }) {
    const result = await api.reqDelQQbind(paramets)
    commit(TYPES.USER_THIRD_LOGIN, { result, type: 'del' })
    cb && cb()
  },

  async postQQlogin({ commit, state }, { paramets, cb }) {
    const result = await api.reqQQlogin(paramets)
    if (result.code == 200) {
      const token = result.result.token
      window.localStorage.setItem('Authorization', token)
      commit(TYPES.USER_LOGIN, { result })
    } else if (result.code == 400) {
      const info = { result }
      commit(TYPES.USER_LOGIN, { result: info })
    }
    commit(TYPES.USER_THIRD_LOGIN, { result, type: 'login' })
    cb && cb()
  },
  // 密码正则校验
  async getUserPassVerify({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserPassVerify(paramets)
    commit(TYPES.USER_PASSWORDVERIFY, { result })
    cb && cb()
  },
  // 密码是否失效
  async getUserPassSecurity({ commit, state }, { paramets, cb }) {
    const result = await api.reqUserPassSecurity(paramets)
    commit(TYPES.USER_PASSWORDSECURITY, { result:result.result })
    cb && cb()
  },
  // 跳转资源库
  async getResourceLibrary({ commit, state }, { paramets, cb }) {
    const result = await api.reqResourceLibrary(paramets)
    commit(TYPES.RESOURCELIBRARY, { result:result.result })
    cb && cb()
  },
}